"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalContext = exports.withModalContext = exports.ModalContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var ModalContext = /*#__PURE__*/React.createContext({
  setHasModalSection: function setHasModalSection() {},
  removeHasModalSection: function removeHasModalSection() {},
  callContextFunctions: function callContextFunctions() {},
  hasModalSection: false,
  isMobileFullPage: false,
  isInsideModal: false,
  closable: false
});
exports.ModalContext = ModalContext;
ModalContext.displayName = "ModalOrbitContext";

var withModalContext = function withModalContext(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ModalContext.Consumer, null,
    /* $FlowFixMe(>=0.115.0) This comment suppresses an error found when upgrading Flow
     * to v0.115.0. To view the error, delete this comment and run Flow. */
    function (contextProps) {
      return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({}, props, contextProps));
    });
  };
};

exports.withModalContext = withModalContext;

var useModalContext = function useModalContext() {
  return React.useContext(ModalContext);
};

exports.useModalContext = useModalContext;